module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive wgxx"
  }, [_c('div', [_c('Table', {
    attrs: {
      "show-header": false,
      "columns": _vm.colums,
      "data": _vm.list,
      "border": true,
      "loading": _vm.loading
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination"
  }, [_c('Page', {
    attrs: {
      "page-size": _vm.LIST_COUNT,
      "current": _vm.page,
      "total": _vm.total,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d63ae5a0","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/notification/vendorsViolationVerify.vue
// module id = 901
// module chunks = 0